module.exports = __webpack_public_path__ + "media/images/japan/tokyo_guide/restaurants_1-d0dd76524c197c2dcc7de1f88790128e.jpg";